export function mergeItemInList<T>(list: T[], item: T, field: string = 'id'): T[] {
  const newList = [...list];
  for (let i = 0; i < newList.length; i++) {
    if (newList[i][field] == item[field]) {
      newList[i] = item;
      return newList;
    }
  }
  return [...newList, item];
}